import React, {useContext} from 'react';
import style from './Header.module.css';
import cityPanoramaStyle from './CityPanorama.module.css';
import cityPanoramaImg from '../assets/images/city panorama.png';
import WaveHeaderSvg from "../assets/svg/WaveHeaderSvg";
import {CommonContext} from "../context";
import SensorInMaintenanceWarningMessage from "./SensorInMaintenanceWarningMessage";

function Header() {

    const {isSensorInMaintenance} = useContext(CommonContext);

    function showWarningMessage() {
        if (isSensorInMaintenance) {
            return <div className={style.warningMessageWrapper}>
                <SensorInMaintenanceWarningMessage />
            </div>;
        }
        return <></>;
    }

    return (
        <div className={style.main}>
            <div className={cityPanoramaStyle.backgroundCityPanorama}>
                <img src={cityPanoramaImg} alt="" className={cityPanoramaStyle.cityPanoramaImg}/>
            </div>

            <div className={style.backgroundWave}>
                <WaveHeaderSvg className={style.waveSvg} />
            </div>

            <div className={style.bigScreen}>
                <div className={style.title}>
                    JEZIORKO CZERNIAKOWSKIE
                </div>

                <div className={style.subtext}>
                    Monitorujemy jakość wody i udostępniamy dane online,<br/> aby każdy mógł sprawdzić jej stan.
                </div>
            </div>

            <div className={style.smallScreen}>
                <div className={style.title}>
                    MONITORING <br/>
                    JEZIORKA CZERNIAKOWSKIEGO
                </div>
            </div>

            {showWarningMessage()}
        </div>
    );
}

export default Header;